(function() {
  'use strict';

  // --- Hero Slideshow ---
  var hero = document.querySelector('.hp-hero');
  if (!hero) return;

  var slides = hero.querySelectorAll('.hp-hero__slide');
  var dots = hero.querySelectorAll('.hp-hero__dot');
  var prevBtn = hero.querySelector('.hp-hero__arrow--prev');
  var nextBtn = hero.querySelector('.hp-hero__arrow--next');
  var counter = hero.querySelector('.hp-hero__counter-current');
  var current = 0;
  var total = slides.length;
  var interval = 6000;
  var timer = null;
  var paused = false;

  function goToSlide(index) {
    if (index === current || total < 2) return;

    // Remove active from current
    slides[current].classList.remove('hp-hero__slide--active');
    dots[current].classList.remove('hp-hero__dot--active');
    dots[current].classList.add('hp-hero__dot--done');

    current = ((index % total) + total) % total;

    // Reset all dots if looping back to start
    if (current === 0) {
      dots.forEach(function(d) { d.classList.remove('hp-hero__dot--done'); });
    }

    // Activate new
    slides[current].classList.add('hp-hero__slide--active');
    dots[current].classList.remove('hp-hero__dot--done');
    dots[current].classList.add('hp-hero__dot--active');

    // Update counter
    if (counter) {
      counter.textContent = String(current + 1).padStart(2, '0');
    }
  }

  function nextSlide() {
    goToSlide(current + 1);
  }

  function prevSlide() {
    goToSlide(current - 1);
  }

  function startAutoplay() {
    stopAutoplay();
    timer = setInterval(function() {
      if (!paused) nextSlide();
    }, interval);
  }

  function stopAutoplay() {
    if (timer) clearInterval(timer);
  }

  // Dot clicks
  dots.forEach(function(dot) {
    dot.addEventListener('click', function() {
      var index = parseInt(this.dataset.dot, 10);
      // Reset all dots
      dots.forEach(function(d) { d.classList.remove('hp-hero__dot--done', 'hp-hero__dot--active'); });
      goToSlide(index);
      startAutoplay();
    });
  });

  // Arrow clicks
  if (prevBtn) prevBtn.addEventListener('click', function() { prevSlide(); startAutoplay(); });
  if (nextBtn) nextBtn.addEventListener('click', function() { nextSlide(); startAutoplay(); });

  // Pause on hover
  hero.addEventListener('mouseenter', function() { paused = true; });
  hero.addEventListener('mouseleave', function() { paused = false; });

  // Keyboard
  hero.setAttribute('tabindex', '0');
  hero.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowLeft') { prevSlide(); startAutoplay(); }
    if (e.key === 'ArrowRight') { nextSlide(); startAutoplay(); }
  });

  // Start
  if (total > 1) startAutoplay();

  // --- Stats Counter Animation ---
  var stats = document.querySelectorAll('.hp-stats__number');
  if (stats.length > 0) {
    var observed = false;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && !observed) {
          observed = true;
          animateCounters();
          observer.disconnect();
        }
      });
    }, { threshold: 0.3 });

    observer.observe(stats[0].closest('.hp-stats') || stats[0]);
  }

  function animateCounters() {
    stats.forEach(function(el) {
      var target = parseInt(el.dataset.count, 10);
      var suffix = el.dataset.suffix || '';
      var duration = 2000;
      var start = performance.now();

      function tick(now) {
        var progress = Math.min((now - start) / duration, 1);
        // Ease out cubic
        var eased = 1 - Math.pow(1 - progress, 3);
        var value = Math.round(eased * target);
        el.textContent = value.toLocaleString() + suffix;
        if (progress < 1) requestAnimationFrame(tick);
      }

      requestAnimationFrame(tick);
    });
  }
})();
